var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m24 11.132-.877-.863c-4.089-4.025-10.726-4.025-14.815 0a10.157 10.157 0 0 0 0 14.53L24 40.245l15.692-15.448a10.157 10.157 0 0 0 0-14.53c-4.09-4.024-10.726-4.024-14.815 0l-.877.864ZM24 42 7.431 25.689a11.407 11.407 0 0 1 0-16.31c4.576-4.505 11.994-4.505 16.569 0 4.575-4.505 11.993-4.505 16.569 0a11.407 11.407 0 0 1 0 16.31z",
  clipRule: "evenodd"
})));
export { SvgHeart as ReactComponent };